import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=e93d8b6c&"
import script from "./AdminIndex.vue?vue&type=script&lang=js&"
export * from "./AdminIndex.vue?vue&type=script&lang=js&"
import style0 from "./AdminIndex.vue?vue&type=style&index=0&id=e93d8b6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports